import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Itinerary from '../components/itinerary/Itinerary';
import FloatingActionButton from '../components/home/FloatingActionButton';

const ItineraryPage = () => {
  // Get the ID parameter from the URL
  const { id } = useParams();

  // Scroll to top on navigation
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  // Now you can use the trip ID to fetch data or pass it to your Itinerary component
  // Passing id as tripId prop
  return (
    <div>
      <Itinerary tripId={id} />
      <FloatingActionButton hideOnMobile={true} />
    </div>
  );
};

export default ItineraryPage;